<template>
  <div class="service">
    <div class="service_tab">
      <div
        :class="['service_tab_item', tabIndex == item.id ? 'line' : '']"
        :data-tab="item.id"
        v-for="item in tabList"
        :key="item.id"
        @click="chooseTab($event)"
      >
        {{ item.tab }}
      </div>
    </div>
    <div class="service_con" v-show="tabIndex == 1">
      <img src="../../static/other/service.png" alt="" />
      <div class="service_con_form">
        <el-form label-position="right" label-width="100px" :model="serverBox">
          <el-form-item label="保函编号：">
            <el-input
              v-model="policyNo"
              placeholder="请输入保函编号"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="投标人：" >
            <el-input v-model="serverBox.name" placeholder="请输入投标人"></el-input>
          </el-form-item> -->
          <el-form-item label="手机号码：">
            <el-input
              v-model="phoneNumber"
              maxlength="11"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input v-model="code" placeholder="请输入验证码">
              <template slot="append">
                <span style="cursor: pointer" v-show="show" @click="getCode"
                  >获取验证码</span
                >
                <span v-show="!show">{{ count }}秒重发</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit(2)">提交</el-button>
          </el-form-item>
          <el-form-item>
            <div style="font-size: 12px; color: rgb(244, 85, 85)">
              *仅可查验本平台保单
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="service_con" v-show="tabIndex == 2">
      <img src="../../static/other/apply.png" alt="" />
      <div class="service_con_form">
        <el-form label-position="right" label-width="100px" :model="serverBox">
          <el-form-item label="保函编号：">
            <el-input
              v-model="policyNo"
              placeholder="请输入保函编号"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="出函机构：" >
            <el-input v-model="serverBox.name" placeholder="请输入出函机构"></el-input>
          </el-form-item> -->
          <el-form-item label="手机号码：">
            <el-input
              v-model="phoneNumber"
              placeholder="请输入手机号码"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="理赔原因：">
            <el-input
              type="textarea"
              :rows="2"
              v-model="claimReason"
              maxlength="50"
              placeholder="请输入理赔原因"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="验证码：">
            <el-input v-model="code" placeholder="请输入验证码">
              <template slot="append">
                <span style="cursor: pointer" v-show="show" @click="getCode"
                  >获取验证码</span
                >
                <span v-show="!show">{{ count }}秒重发</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit(3)">理赔申请</el-button>
          </el-form-item>
          <el-form-item>
            <div style="font-size: 12px; color: rgb(244, 85, 85)">
              *仅可申请理赔本平台保单
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog
      title="查验详情"
      :visible.sync="centerDialogVisible"
      width="600px"
      center
    >
      <el-form :model="dialogForm">
        <el-form-item label="投保方名称： " :label-width="formLabelWidth">
          <div class="dialog">{{ dialogForm.applicantName }}</div>
        </el-form-item>
        <el-form-item label="机构代码：" :label-width="formLabelWidth">
          <div>{{ dialogForm.applicantCode }}</div>
        </el-form-item>
        <el-form-item label="出函机构：" :label-width="formLabelWidth">
          <div>
            <img :src="dialogForm.insurCompanyLogoUrl" alt="" style="width: 250px;"/>
            <!-- <span>{{ dialogForm.insurCompanyName }}</span> -->
          </div>
        </el-form-item>
        <el-form-item label="投保时间：" :label-width="formLabelWidth">
          <div>{{ dialogForm.orderIssuingTime }}</div>
        </el-form-item>
        <el-form-item label="保单号：" :label-width="formLabelWidth">
          <div>{{ dialogForm.policyNo }}</div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '354px', height: '216px' }"
    />
  </div>
</template>

<script>
import {
  claimApply,
  queryGuarantee,
  sendCheckCode,
  useCheckCode,
  generateClaimUrl
} from "../api/basic/index.js";
import { validatePhone, validateTelephone } from "@/utils/validate";
import Verify from "@/components/verifition/Verify.vue";
import axios from "axios";
export default {
  name: "",
  mixins: [],
  components: {
    Verify,
  },
  provide() {
    return {
      sendCheckCodeWithSlider: this.sendCheckCodeWithSlider
    };
  },
  data() {
    return {
      dialogForm:{},
      centerDialogVisible:false,
      formLabelWidth:'100px',
      title:'',
      phoneNumber: "",
      policyNo: "",
      claimReason:'',
      dataForm: {
        cooperationArea: "",
        phoneNumber: "",
        policyNo: "",
        businessType: "",
      },
      code: "",
      show: true,
      timer: null,
      count: "获取验证码",
      tabIndex: 1,
      tabList: [
        {
          tab: "保函查验",
          id: "1",
        },
        {
          tab: "理赔申请",
          id: "2",
        }
      ],
      serverBox:{}
    };
  },
  computed: {},
  watch: {
    $route: {
      handler: function (val) {
        this.tabIndex = val.query.tabIndex;
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    let tabIndex = this.$route.query.tabIndex;
    this.tabIndex = tabIndex;
  },
  mounted() {},
  methods: {
    clear(){
      this.claimReason = ''
      this.phoneNumber = "";
      this.policyNo = "";
      this.code = "";
      this.show= true;
      this.timer=null;
      this.count="获取验证码";
    },
    chooseTab(e) {
      let tabIndex = e.target.dataset.tab;
      this.tabIndex = tabIndex;
      this.clear()
    },
    getCode() {
      if (!this.phoneNumber) {
        this.$message.error("请先输入手机号");
        return;
      }
      if (
        (!validatePhone(this.phoneNumber) &&
          !validateTelephone(this.phoneNumber)) ||
        this.phoneNumber.length != 11
      ) {
        this.$message({
          title: "提示",
          message: "请输入正确的联系电话",
          type: "warning",
        });
      } else {
        //查询是否进行行为认证
        this.$refs.verify.show();
      }
    },
    // 发送验证码带滑块
    async sendCheckCodeWithSlider(sliderParams) {
      this.getVerifyCode();
      const params = {
        phone: this.phoneNumber,
        businessCode: "globalTemplate",
        graphicData:sliderParams,
      }
      try{
        await sendCheckCode(params)
        this.$message.success({
          title: '提示',
          message: '短信发送成功，请注意查收',
          type: 'success',
        });
        return true
      }catch (e){
        return false
      }
    },
    getVerifyCode() {
      this.show = false;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    submit(businessType) {
      if (this.phoneNumber && this.policyNo && this.code) {
        const phoneParams = {
          phone: this.phoneNumber,
          businessCode: "globalTemplate",
          checkCode: this.code,
        };
        useCheckCode(phoneParams).then((phoneRes) => {
          if (phoneRes.data.resultCode == "200") {
            if (businessType == 2) {
              this.queryGuarantee();
            } else if (businessType == 3) {
              console.log('理赔')
              this.claimApply();

            }
          }
        });
      } else {
        this.$message.error("请按照页面信息填写完整");
      }
    },
    queryGuarantee() {
      let dataForm = this.dataForm;
      dataForm.phoneNumber = this.phoneNumber;
      dataForm.policyNo = this.policyNo;
      dataForm.businessType = 2;
      queryGuarantee(dataForm).then((res) => {
        if (res.data.resultCode == "200") {
          this.clear()
          if(res.data.data){
            this.dialogForm = res.data.data
            this.centerDialogVisible = true
          }else{
            this.$alert(
              "此保单平台不存在",
              "查验结果",
              {
                confirmButtonText: "确定",
              }
            );
          }

        }
      });
    },
    claimApply() {
      let dataForm = this.dataForm;
      dataForm.phoneNumber = this.phoneNumber;
      dataForm.policyNo = this.policyNo;
      dataForm.businessType = 3;
      dataForm.claimReason =this.claimReason
      let domain = window.location.host
      let url = (domain == 'dinghanwang.com' ) ? 'https://tb.dinghanwang.com':'https://open-test.dinghanwang.com';
      var params = {
        policyNo: dataForm.policyNo,
        authenticationType: 'official',
        environmentUrl: url,
        claimApplyPhone:this.phoneNumber
      };
      generateClaimUrl(params).then((res) => {
        if (res.data.resultCode == "200") {
          this.clear()
          if (res.data.data) {
            let url = res.data.data
            console.log(url);
            window.open(url)
          }else{
            this.$alert(
              "此保单平台不存在",
              "申请提交失败",
              {
                confirmButtonText: "确定",
              }
            );
          }
        }
      });
      // claimApply(dataForm).then((res) => {
      //   if (res.data.resultCode == "200") {
      //     this.clear()
      //     if (res.data.data) {
      //       // this.$alert(
      //       //   "已经收到您的理赔申请，稍后会有客服人员联系您具体理赔事宜，如有其他问题可以拨打客服电话：400-6399580",
      //       //   "申请提交成功",
      //       //   {
      //       //     confirmButtonText: "确定",
      //       //   }
      //       // );
      //       this.claimApplyAuto(dataForm)   // 保单验证存在，跳转理赔
      //     }else{
      //       this.$alert(
      //         "此保单平台不存在",
      //         "申请提交失败",
      //         {
      //           confirmButtonText: "确定",
      //         }
      //       );
      //     }
      //   }
      // });
    },
    claimApplyAuto(dataForm){ // 生成链接跳转理赔
      let domain = window.location.host
      // let url = (domain == 'dinghanwang.com' ) ? 'https://tb.dinghanwang.com/api':'https://open-test.dinghanwang.com/api';
      let url = 'http://localhost:8081'
      let url1 = '/auto/claim/generateClaimUrl'
      axios({
        method: "post",
        url: url+url1,
        cache: false,
        dataType: "json",
        contentType: "application/json;",
        data: JSON.stringify({
          policyNo: dataForm.policyNo,
          environmentUrl: url,
        })
      }).then(res=>{
        console.log(res.data.data)
        let url = res.data.data
        console.log(url);
        // let str = url.substr(url.indexOf("?"))
        // let a =  (domain == 'dinghanwang.com' ) ? 'https://tb.dinghanwang.com/tc/autoClaim':'https://open-test.dinghanwang.com/tc/autoClaim';
        window.open(url)
      })
    },
  },
};
</script>

<style scoped >
.service {
  width: 1200px;
  margin: auto;
}
.service_tab {
  display: flex;
  justify-content: center;
  align-items: center;
}
.service_tab_item {
  flex-grow: 1;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
}
.line {
  border-bottom: 3px solid rgb(26, 127, 221);
  color: rgb(26, 127, 221);
}
.service_con {
  width: 1040px;
  height: 460px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 40px auto;
  padding: 50px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.service_con img {
  width: 350px;
  height: 350px;
  background: #e9e9e9;
}
.service_con_form {
  width: 560px;
  /* height: 350px; */
  margin-left: 20px;
}
/deep/ .el-dialog__body {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog {
  margin-left: 10px;
}
</style>
